import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { SubscriptionType } from './subscription-type.model';
import { SubscriptionTypeService } from './subscription-type.service';

@Component({
    selector: 'jhi-subscription-type-detail',
    templateUrl: './subscription-type-detail.component.html'
})
export class SubscriptionTypeDetailComponent implements OnInit, OnDestroy {

    subscriptionType: SubscriptionType;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private subscriptionTypeService: SubscriptionTypeService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['subscriptionType', 'recurrence']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load(id) {
        this.subscriptionTypeService.find(id).subscribe(subscriptionType => {
            this.subscriptionType = subscriptionType;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type-detail.component.ts